var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2022 13.8404L9.77209 19.7036C10.3874 19.7036 10.6539 19.4474 10.9735 19.1397L13.8585 16.4675L19.8365 20.7105C20.9329 21.3027 21.7053 20.9909 22.0011 19.733L25.925 1.91247L25.9261 1.91142C26.2738 0.340624 25.34 -0.273623 24.2718 0.111725L1.20705 8.67023C-0.367066 9.26243 -0.343232 10.1129 0.939465 10.4983L6.83619 12.2759L20.5331 3.96941C21.1777 3.55571 21.7638 3.78461 21.2817 4.1983L10.2022 13.8404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.64bc8010db006d8fba0f1c1cb186c216.svg";
export { ForwardRef as ReactComponent };